import React, { forwardRef, ReactNode } from 'react';
import {
  Link as ChakraLink,
  LinkProps,
  useStyleConfig,
} from '@chakra-ui/react';

interface Props extends Omit<LinkProps, `css`> {
  children?: ReactNode;
  variant?: `active` | `inactive` | `red`;
  href?: string;
}

export const Link = forwardRef<HTMLAnchorElement, Props>(
  ({ children, href, variant, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`Anchor`, { variant });

    return (
      <ChakraLink href={href} ref={ref} __css={styles} {...props}>
        {children}
      </ChakraLink>
    );
  }
);
export type { Props as LinkProps };
